import type { CotAffiliation } from '../types/cot.js';

/**
 * Map of CoT affiliation to display color (hex).
 * Replaces the if/startsWith chain from the prototype.
 */
export const AFFILIATION_COLORS: ReadonlyMap<CotAffiliation, string> = new Map([
  ['friendly', '#4caf50'],
  ['hostile', '#f44336'],
  ['neutral', '#ffeb3b'],
  ['unknown', '#2196f3'],
]);

/** Default color when affiliation cannot be determined */
export const DEFAULT_COT_COLOR = '#888888';

/** Contact marker colors */
export const CONTACT_MARKER_COLOR = '#1976d2';
export const CONTACT_MARKER_FILL = '#64b5f6';

/**
 * Resolve a CoT type string to its display color.
 * Extracts affiliation from the second segment of the type code.
 */
export function cotTypeToColor(type: string): string {
  if (!type) return DEFAULT_COT_COLOR;

  const segments = type.split('-');
  const affiliationChar = segments[1];
  if (!affiliationChar) return DEFAULT_COT_COLOR;

  const affiliationMap: ReadonlyMap<string, CotAffiliation> = new Map([
    ['f', 'friendly'],
    ['h', 'hostile'],
    ['n', 'neutral'],
    ['u', 'unknown'],
  ]);

  const affiliation = affiliationMap.get(affiliationChar);
  if (!affiliation) return DEFAULT_COT_COLOR;

  return AFFILIATION_COLORS.get(affiliation) ?? DEFAULT_COT_COLOR;
}
